import * as Model from '../../core/1.4/model'

// Alias for convenience.
class KundenkampagnenResponse extends Model.Produkt.GetKundenkampagnen.Response { }

/**
 * Customer campaigns helper.
 */
export default class Kundenkampagnen extends KundenkampagnenResponse {
  /**
   * Instantiates a new customer campaigns helper.
   */
  public constructor (kundenkampagnen: KundenkampagnenResponse) {
    super()
    Object.assign(this, kundenkampagnen)
  }

  /**
   * Distributor codes.
   */
  public get BSCodes () {
    return this.Kundenkampagnen.flatMap(kundenkampagne =>
      kundenkampagne.Bonussteuerungen.map(bonus => bonus.BSCode)
    )
  }

  /**
   * Returns all parameters of the customer campaigns.
   */
  public get Parameters () {
    return this.Kundenkampagnen.flatMap(kundenkampagne => kundenkampagne.Parameter)
  }

  /**
   * Returns parameter identified by category and subcategory.
   */
  public getParameter (hauptkategorie: string, unterkategorie?: string) {
    return this.Parameters.find(parameter =>
      parameter.Hauptkategorie === hauptkategorie &&
      parameter.Unterkategorie === (unterkategorie || null)
    )
  }
}
